import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Employment } from '../../models/employment-model';
import { EmploymentTypeEnum } from '../../models/mortgage.model';
import { isEmploymentEndDateInFuture } from '../../utils/employment-duration.utils';

@Component({
    selector: 'employment-history-dialog',
    templateUrl: 'employment-history-dialog.component.html',
    standalone: false
})

export class EmploymentHistoryDialogComponent implements OnInit {

  @ViewChild('employmentInfoForm') employmentInfoForm: NgForm | undefined;

  isEndDateInFutureMessageShowing: boolean = false;

  private _employment!: Employment;

  constructor(public activeModal: NgbActiveModal) { }

  @Input()
  public set employment(employment: Employment) {
    this._employment = employment;
  }

  public get employment(): Employment {
    return this._employment;
  }

  onSaveClicked = () => {
    this.employmentInfoForm?.form.markAllAsTouched();
    this.isEndDateInFutureMessageShowing = this.employment.employmentType === EmploymentTypeEnum.FormerEmployer
      && isEmploymentEndDateInFuture(this.employment.endDate);
    if (this.employmentInfoForm?.form.valid && !this.isEndDateInFutureMessageShowing) {
      this.activeModal.close(this.employment);
    }
  }

  ngOnInit() { }

  public get header(): string {
    return "Employment History";
  }
}
